/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetails } from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetails';
import {
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetailsFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetailsFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetailsToJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetailsToJSONTyped,
} from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetails';

/**
 * 
 * @export
 * @interface UpdateLeadWaitlistStatusRequest
 */
export interface UpdateLeadWaitlistStatusRequest {
    /**
     * 
     */
    status?: UpdateLeadWaitlistStatusRequestStatusEnum;
    /**
     * 
     */
    details?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetails;
}


/**
 * @export
 */
export const UpdateLeadWaitlistStatusRequestStatusEnum = {
    Waitlisted: 'Waitlisted',
    Cleared: 'Cleared',
    Cancelled: 'Cancelled',
} as const;
export type UpdateLeadWaitlistStatusRequestStatusEnum = typeof UpdateLeadWaitlistStatusRequestStatusEnum[keyof typeof UpdateLeadWaitlistStatusRequestStatusEnum];


/**
 * Check if a given object implements the UpdateLeadWaitlistStatusRequest interface.
 */
export function instanceOfUpdateLeadWaitlistStatusRequest(value: object): value is UpdateLeadWaitlistStatusRequest {
    return true;
}

export function UpdateLeadWaitlistStatusRequestFromJSON(json: any): UpdateLeadWaitlistStatusRequest {
    return UpdateLeadWaitlistStatusRequestFromJSONTyped(json, false);
}

export function UpdateLeadWaitlistStatusRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLeadWaitlistStatusRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : json['status'],
        'details': json['details'] == null ? undefined : FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetailsFromJSON(json['details']),
    };
}

export function UpdateLeadWaitlistStatusRequestToJSON(json: any): UpdateLeadWaitlistStatusRequest {
    return UpdateLeadWaitlistStatusRequestToJSONTyped(json, false);
}

export function UpdateLeadWaitlistStatusRequestToJSONTyped(value?: UpdateLeadWaitlistStatusRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'details': FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistDetailsToJSON(value['details']),
    };
}

